define("shared/helpers/to-fixed", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f

  var _default = (0, _helper.helper)((params, _ref) => {
    let {
      decimals
    } = _ref;
    const isDecimal = params[0] % 1 !== 0;

    if (typeof params[0] !== 'number' || params[0] === '') {
      return '';
    }

    if (params[0] === 0) {
      return params[0];
    }

    if (isDecimal && decimals) {
      return params[0].toFixed(decimals);
    }

    return params[0];
  });

  _exports.default = _default;
});